<template>
  <app-layout :title="``">
    <template #header>
      <div class="flex w-full justify-between items-center">
        <h2 class="flex flex-col md:flex-row md:items-center md:text-[24px] text-[14px] leading-none" v-html="title">
        </h2>
        <div class="flex gap-x-[5px] md:gap-x-[40px] justify-between">
          <app-useful-links :items="usefulLinks" />
          <jet-danger-button type="link"
            :href="route(`${this.prefixRoute}.remove`, this.model.id)">Remove</jet-danger-button>
        </div>
      </div>
    </template>

    <div class="mx-auto py-4">
      <div class="w-full">
        <nav class="border-b text-sm flex justify-start overflow-scroll">
          <a :class="{
            'inline-block py-2 mr-4 text-slate-600 hover:text-slate-900': true,
            'border-b-2 border-orange-600 ': tab === 1,
          }" href="#" @click="currentTab(1)">Data</a>
          <a :class="{
            'inline-block py-2 mr-4 text-slate-600 hover:text-slate-900': true,
            'border-b-2 border-orange-600 ': tab === 2,
          }" href="#" @click="currentTab(2)">Activity</a>
        </nav>
        <div class="pt-10">
          <div v-if="tab === 1">
            <form @submit.prevent="submit">
              <div class="grid grid-cols-6 gap-6">
                <div class="col-span-6 sm:col-span-4">
                  <jet-label for="source_name" value="Source name" />
                  <jet-input id="source_name" type="text" class="block w-full mt-1" v-model="form.source_name"
                    autofocus />
                  <jet-input-error :message="form.errors.source_name" class="mt-2" />
                </div>

                <div class="col-span-6 sm:col-span-4">
                  <jet-label for="link" value="Link" />
                  <jet-input id="link" type="text" class="block w-full mt-1" v-model="form.link" autofocus />
                  <jet-input-error :message="form.errors.link" class="mt-2" />
                </div>

                <div class="col-span-6 sm:col-span-4">
                  <jet-label for="year" value="Year" />
                  <jet-input id="year" type="text" class="block w-full mt-1" v-model="form.year" autofocus />
                  <jet-input-error :message="form.errors.year" class="mt-2" />
                </div>

                <div class="col-span-6 sm:col-span-4">
                  <jet-label for="description" value="Description" />
                  <jet-input id="description" type="text" class="block w-full mt-1" v-model="form.description"
                    autofocus />
                  <jet-input-error :message="form.errors.description" class="mt-2" />
                </div>

                <div class="col-span-6 sm:col-span-4">
                  <jet-label for="custom_html" value="Custom html" />
                  <jet-input id="custom_html" type="text" class="block w-full mt-1" v-model="form.custom_html"
                    autofocus />
                  <jet-input-error :message="form.errors.custom_html" class="mt-2" />
                </div>

                <div class="col-span-6 sm:col-span-4">
                  <jet-label for="sort" value="Sort" />
                  <jet-input id="sort" type="text" class="block w-full mt-1" v-model="form.sort" autofocus />
                  <jet-input-error :message="form.errors.sort" class="mt-2" />
                </div>

                <div class="col-span-6 sm:col-span-4">
                  <jet-label for="published_main_page" value="Published on the main page" />
                  <div class="mt-2 grid grid-cols-1 gap-4">
                    <label class="flex items-center">
                      <jet-checkbox :value="form.published_main_page" v-model:checked="form.published_main_page" />
                      <span class="ml-2 text-sm text-slate-600">Yes</span>
                    </label>
                  </div>
                </div>

                <div class="col-span-6 sm:col-span-4">
                  <jet-label for="preview_text" value="Preview text" />
                  <jet-input id="preview_text" type="text" class="block w-full mt-1" v-model="form.preview_text"
                    autofocus />
                  <jet-input-error :message="form.errors.preview_text" class="mt-2" />
                </div>

                <div class="col-span-6 sm:col-span-4">
                  <image-editor name="logo" label="Logo" desc="" :value="form.logo" :validation-rules="{
                    accept: ['image/png', 'image/jpeg', 'image/gif'],
                    maxSizeInKB: 100000,
                  }" @update="onChangeUniversalNEW('logo', $event)"></image-editor>
                </div>

                <div class="col-span-6 sm:col-span-4">
                  <jet-label for="published" value="Published" />
                  <div class="mt-2 grid grid-cols-1 gap-4">
                    <label class="flex items-center">
                      <jet-checkbox :value="form.published" v-model:checked="form.published" />
                      <span class="ml-2 text-sm text-slate-600">Yes</span>
                    </label>
                  </div>
                </div>

                <div class="col-span-6 sm:col-span-4">
                  <image-editor name="cover" label="Cover" desc="" :value="form.cover" :validation-rules="{
                    accept: ['image/png', 'image/jpeg', 'image/gif'],
                    maxSizeInKB: 100000,
                  }" @update="onChangeUniversalNEW('cover', $event)"></image-editor>
                </div>

                <div class="col-span-6 grid grid-cols-8 gap-6">
                  <div class="col-span-8 md:col-span-2">
                    <image-editor name="cover_sm" label="Cover Mobile" desc="" :value="form.cover_sm" :validation-rules="{
                      accept: ['image/png', 'image/jpeg', 'image/gif'],
                      maxSizeInKB: 100000,
                    }" @update="onChangeUniversalNEW('cover_sm', $event)"></image-editor>
                  </div>
                  <div class="col-span-8 md:col-span-2">
                    <image-editor name="cover_md" label="Cover Tablet" desc="" :value="form.cover_md" :validation-rules="{
                      accept: ['image/png', 'image/jpeg', 'image/gif'],
                      maxSizeInKB: 100000,
                    }" @update="onChangeUniversalNEW('cover_md', $event)"></image-editor>
                  </div>
                  <div class="col-span-8 md:col-span-2">
                    <image-editor name="cover_lg" label="Cover L" desc="" :value="form.cover_lg" :validation-rules="{
                      accept: ['image/png', 'image/jpeg', 'image/gif'],
                      maxSizeInKB: 100000,
                    }" @update="onChangeUniversalNEW('cover_lg', $event)"></image-editor>
                  </div>
                  <div class="col-span-8 md:col-span-2">
                    <image-editor name="cover_xl" label="Cover XL" desc="" :value="form.cover_xl" :validation-rules="{
                      accept: ['image/png', 'image/jpeg', 'image/gif'],
                      maxSizeInKB: 100000,
                    }" @update="onChangeUniversalNEW('cover_xl', $event)"></image-editor>
                  </div>
                </div>
              </div>
              <div class="flex items-center justify-start pt-8">
                <jet-button :class="{ 'opacity-25': form.processing }" :disabled="form.processing">
                  Save
                </jet-button>
                <jet-action-message :on="form.recentlySuccessful" class="ml-3">
                  Saved.
                </jet-action-message>
              </div>
            </form>
          </div>
          <div v-if="tab === 2">
            <ActivityLog modelClass="publication" :modelId="model.id" />
          </div>
        </div>
      </div>
    </div>
  </app-layout>
</template>

<script>
import { defineComponent, onMounted, onUpdated, ref } from 'vue';
import Datepicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css';
import AppLayout from '@/Layouts/AppLayout.vue';
import { useForm } from '@inertiajs/inertia-vue3';
import JetButton from '@/Jetstream/Button.vue';
import JetFormSection from '@/Jetstream/FormSection.vue';
import JetInput from '@/Jetstream/Input.vue';
import JetInputError from '@/Jetstream/InputError.vue';
import JetLabel from '@/Jetstream/Label.vue';
import JetDangerButton from '@/Jetstream/DangerButton.vue';
import JetActionMessage from '@/Jetstream/ActionMessage';
import JetTextarea from '@/Jetstream/Textarea';
import { MediaLibraryAttachment } from '../../../../../vendor_custom/laravel-medialibrary-pro/resources/js/media-library-pro-vue3-attachment';
import { MediaLibraryCollection } from '../../../../../vendor_custom/laravel-medialibrary-pro/resources/js/media-library-pro-vue3-collection';
import draggable from 'vuedraggable';
import JetDialogModal from '@/Jetstream/DialogModal';
import JetSecondaryButton from '@/Jetstream/SecondaryButton';
import VueTagsInput from '@sipec/vue3-tags-input';
import JetCheckbox from '@/Jetstream/Checkbox';
import VueEasyLightbox from 'vue-easy-lightbox/dist/external-css/vue-easy-lightbox.esm.min.js';
import ImageEditor from '@/Components/ImageEditor.vue';
import AppUsefulLinks from '@/Components/usefulLinks.vue';
import ActivityLog from '@/Components/ActivityLog.vue';

export default defineComponent({
  components: {
    draggable,
    AppLayout,
    JetButton,
    JetFormSection,
    JetInput,
    JetInputError,
    JetLabel,
    JetDangerButton,
    JetActionMessage,
    JetTextarea,
    MediaLibraryAttachment,
    MediaLibraryCollection,
    JetDialogModal,
    JetSecondaryButton,
    Datepicker,
    VueTagsInput,
    JetCheckbox,
    VueEasyLightbox,
    ImageEditor,
    AppUsefulLinks,
    ActivityLog
  },
  setup(props) {
    const tab = ref(1);
    const currentTab = (tabNumber) => (tab.value = tabNumber);
    const form = useForm({
      source_name: props.model.source_name,
      link: props.model.link,
      year: props.model.year,
      description: props.model.description,
      custom_html: props.model.custom_html,
      published: props.model.published,
      published_main_page: props.model.published_main_page,
      logo: props.model.logo,
      preview_text: props.model.preview_text,
      sort: props.model.sort,
      cover: props.model.cover,
      cover_sm: props.model.cover_sm,
      cover_md: props.model.cover_md,
      cover_lg: props.model.cover_lg,
      cover_xl: props.model.cover_xl,
    });

    const onChangeUniversalNEW = function (name, img) {
      console.log('--onChangeUniversal sss', img);
      form[name] = img.value;
    };

    return {
      form,
      tab,
      currentTab,
      onChangeUniversalNEW,
    };
  },
  data() {
    return {
      validationErrors: this.$page.props.errors,
    };
  },
  props: {
    model: Object,
    prefixRoute: String,
    title: String,
    usefulLinks: Object,
  },
  methods: {
    submit() {
      this.form.put(route(`${this.prefixRoute}.update`, this.model.id));
    }
  },
});
</script>

<style>
@import 'media-library-pro-styles';

.ghost-card {
  opacity: 0.5;
  background: #f7fafc;
  border: 1px solid #4299e1;
}

.thumb {
  width: 4rem !important;
  height: 4rem !important;
  object-fit: cover !important;
}

.media-library-thumb {
  width: 10rem !important;
  height: 10rem !important;
  margin: 4rem;
}
</style>
